import { Action, createReducer, on } from '@ngrx/store';
import { SidebarItemModel } from '../../models/sidebar-item.model';
import * as fromActions from '../actions';


export const sidebarFeatureKey = 'sidebar';

export interface SidebarState {
  items: SidebarItemModel[];
  loading: boolean;
  loaded: boolean;
}

export const initialState: SidebarState = {
  items: [],
  loading: false,
  loaded: false
};

const sidebarReducer = createReducer(
  initialState,

  on(fromActions.loadSidebar,
    state => ({ ...state, loading: true, loaded: false })
  ),

  on(fromActions.loadSidebarSuccess,
    (state, { items }) => ({ ...state, items, loading: false, loaded: true })
  )
);

export function reducer(state: SidebarState | undefined, action: Action) {
  return sidebarReducer(state, action);
}
